import i18next from "i18next"
class Internationalisation {
  constructor() {
    i18next.init(
      {
        lng: $("html").attr("lang"),
        debug: false,
        resources: {
          en: {
            translation: {
              userWithCount: "{{count}} user",
              userWithCount_plural: "{{count}} users",
              users: {
                selectedCount: "({{count}} user selected)",
                selectedCount_plural: "({{count}} users selected)",
              },
              organizations: {
                selectedCount: "({{count}} organization selected)",
                selectedCount_plural: "({{count}} organizations selected)",
              },
              metasearchNoSuggestionNotice:
                "<span class='no-suggestion-emoji'><img src='/no-results-found.png'</span> No result found!",
              announcementEditNameHint:
                "Edit the name of this announcement to update this banner",
            },
          },
          fr: {
            translation: {
              userWithCount: "{{count}} utilisateur",
              userWithCount_plural: "{{count}} utilisateurs",
              users: {
                selectedCount: "({{count}} utilisateur sélectionné)",
                selectedCount_plural: "({{count}} utilisateurs sélectionnés)",
              },
              organizations: {
                selectedCount: "({{count}} organisation sélectionné)",
                selectedCount_plural: "({{count}} organisations sélectionnés)",
              },
              metasearchNoSuggestionNotice:
                "<span class='no-suggestion-emoji'><img src='/no-results-found.png'</span> Aucun résultat trouvé !",
              announcementEditNameHint:
                "Editez le nom de l'annonce pour mettre à jour ce bandeau",
            },
          },
        },
      },
      function (err, t) {
        // init set content
      }
    )
    window.i18next = i18next
  }
}

export { Internationalisation }
